import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store'
import App from '~components/App'
import axios from 'axios'
import * as Sentry from '@sentry/react'

const container = document.getElementById('app')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

//  Append 'refresh-cache' to API requests if it's in the URL
axios.interceptors.request.use(function (config) {
  const params = new URLSearchParams(window.location.search)

  if (params.has('refresh-cache')) {
    config.params = {
      ...config.params,
      'refresh-cache': true
    }
  }

  return config
})

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN_REACTJS,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept()
}
